import React, { KeyboardEvent, MouseEvent, useEffect, useState } from 'react';
import { DeadlineDate } from 'src/components/PortalList/PortalDeadlineDate';
import { ISigningCaseListItem } from 'src/models';
import {
  AgreementDeadlineMobile,
  TableCellMobile,
  TableCellTitle,
  TableCellBig,
  TableCellLast,
} from 'src/components';
import {
  Row,
  Title,
  AgreementStatus,
  AgreementStatusMobile,
} from './SigningCasesListItem.styles';
import { getTextFromAgreementStatus } from 'src/utils/getTextFromAgreementStatus';
import { getAgreementColor } from 'src/utils/getAgreementColor';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

type TableRowEventType = MouseEvent<HTMLTableRowElement>;
type TableRowKeyboardEventType = KeyboardEvent<HTMLTableRowElement>;

interface Props extends RouteComponentProps<any> {
  document: ISigningCaseListItem;
  onClick?: (e: TableRowEventType, document: ISigningCaseListItem) => void;
  onKeyDown?: (
    e: TableRowKeyboardEventType,
    document: ISigningCaseListItem
  ) => void;
}

const SigningCasesListItem = ({ document, onClick, onKeyDown }: Props) => {
  const color = getAgreementColor(
    document.status,
    document.contractingPartyType
  );

  const onSigningCaseClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (onClick) {
      onClick(e as TableRowEventType, document);
    }
  };
  const onSigningCaseKeyboardClick = (e: TableRowKeyboardEventType) => {
    if (onKeyDown) {
      onKeyDown(e, document);
    }
  };

  const [caseStatus, setCaseStatus] = useState(document.status);

  useEffect(() => {
    setCaseStatus(document.status);
  }, [document.status]);

  return (
    <Row
      role="row"
      contractingPartyType={document.contractingPartyType}
      documentStatus={document.status}
      tabIndex={0}
      onClick={onSigningCaseClick}
      onKeyDown={onSigningCaseKeyboardClick}
    >
      <TableCellTitle role="cell" color={color}>
        <Link
          style={{
            textDecoration: 'none',
            color: 'inherit',
          }}
          to="#"
          onClick={e => {
            e.preventDefault();
            onSigningCaseClick(e);
          }}
        >
          <Title
            title={document.name}
            subtitle={document.contractingPartyName}
          />
        </Link>
      </TableCellTitle>
      <TableCellBig role="cell">
        <Link
          style={{
            textDecoration: 'none',
            color: 'inherit',
          }}
          to="#"
          onClick={e => {
            e.preventDefault();
            onSigningCaseClick(e);
          }}
        >
          <DeadlineDate date={document.date} />
        </Link>
      </TableCellBig>
      <TableCellLast role="cell" align="right" hide={true}>
        <Link
          style={{
            textDecoration: 'none',
            color: 'inherit',
          }}
          to="#"
          onClick={e => {
            e.preventDefault();
            onSigningCaseClick(e);
          }}
        >
          <AgreementStatus
            status={document.status}
            color={color}
            displayedStatusText={getTextFromAgreementStatus(caseStatus)}
          />
        </Link>
      </TableCellLast>
      <TableCellMobile role="cell" color={color}>
        <AgreementDeadlineMobile date={document.date} />
        <AgreementStatusMobile status={document.status} color={color} />
      </TableCellMobile>
    </Row>
  );
};

export const SigningCasesListItemWithRouter = withRouter(SigningCasesListItem);
export default SigningCasesListItem;
